import moment, {Duration} from 'moment';

export enum CandlePeriod {
    ONE_MINUTE      = 'ONE_MINUTE',
    FIVE_MINUTES    = 'FIVE_MINUTES',
    TEN_MINUTES     = 'TEN_MINUTES',
    FIFTEEN_MINUTES = 'FIFTEEN_MINUTES',
    THIRTY_MINUTES  = 'THIRTY_MINUTES',
    HOUR            = 'HOUR',
    DAY             = 'DAY',
    WEEK            = 'WEEK',
    MONTH           = 'MONTH'
}

export const CANDLE_PERIOD_MOMENT_DURATION_DICT: { [candlePeriod in CandlePeriod]: Duration } = {
    [CandlePeriod.ONE_MINUTE]:      moment.duration(1, 'minute'),
    [CandlePeriod.FIVE_MINUTES]:    moment.duration(5, 'minute'),
    [CandlePeriod.TEN_MINUTES]:     moment.duration(10, 'minute'),
    [CandlePeriod.FIFTEEN_MINUTES]: moment.duration(15, 'minute'),
    [CandlePeriod.THIRTY_MINUTES]:  moment.duration(30, 'minute'),
    [CandlePeriod.HOUR]:            moment.duration(1, 'hour'),
    [CandlePeriod.DAY]:             moment.duration(1, 'day'),
    [CandlePeriod.WEEK]:            moment.duration(1, 'week'),
    [CandlePeriod.MONTH]:           moment.duration(1, 'month')
};
